import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { DevToolsProvider } from '@ps-gui/ui';
import { FillMode } from '../generators/field-value.generator';
import { SumMode, TableRequest } from '../generators/table.generator';

const SUM_MODE_LABELS: { mode: SumMode; label: string }[] = [
  { mode: 'exact', label: 'exakt passend' },
  { mode: 'diverging', label: 'abweichend (löst Warnung aus)' },
  { mode: 'none', label: 'leer lassen' },
];

/** The panel drives two actions through one provider, so the payload says which one it is. */
export type TableAction = { type: 'generate'; request: TableRequest } | { type: 'removeAll' };

const MIN_ROW_COUNT = 2;
const MAX_ROW_COUNT = 30;
const DEFAULT_ROW_COUNT = 10;

@Component({
  selector: 'ct-extraction-table-dev-tools-panel',
  templateUrl: './table-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePanelComponent {
  readonly provider = input.required<DevToolsProvider<TableAction>>();

  /** Only a table with a sum field can diverge from it, so only that one gets the choice. */
  readonly hasSum = input(false);

  protected readonly sumModes = SUM_MODE_LABELS;
  protected readonly minRowCount = MIN_ROW_COUNT;
  protected readonly maxRowCount = MAX_ROW_COUNT;

  protected readonly rowCount = signal(DEFAULT_ROW_COUNT);
  protected readonly sumMode = signal<SumMode>('exact');

  protected onRowCountInput(value: string): void {
    this.rowCount.set(Number(value));
  }

  protected generate(mode: FillMode): void {
    this.provider().apply({
      type: 'generate',
      request: {
        rowCount: this.rowCount(),
        mode,
        sumMode: this.hasSum() ? this.sumMode() : 'none',
      },
    });
  }

  protected removeAll(): void {
    this.provider().apply({ type: 'removeAll' });
  }
}
